export class LogViewModel {
    store;
    name = this.constructor.name;
    constructor(store) {
        this.store = store;
    }
    get errors() {
        return this.store.errors;
    }
    get lastError() {
        return this.store.lastError;
    }
    get lastSuccess() {
        return this.store.lastSuccess;
    }
    clearLastError() {
        this.store.lastError = null;
    }
    clearErrors() {
        this.store.clearErrors();
    }
    clearLastSuccess() {
        this.store.lastSuccess = null;
    }
    logAppError(message, localizedKey) {
        this.store.logError({
            appMessage: message,
            localizedKey,
        });
    }
    logAppSuccess(message, localizedKey) {
        this.store.logSuccess(message, localizedKey);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    notifyLocationChanged(route, params) {
    }
}
